<template>
  <!-- eslint-disable max-len -->
  <section class="amp-offers">
    <div class="amp-offers__content">
      <h3 class="amp-offers__heading">
        Now, select up to $750 in savings
      </h3>
      <p class="amp-offers__body mt-4">
        Visit MYMOVE.com to choose your offers. Just check the box and click "Continue" to autofill your MYMOVE.com registration. You will be redirected from the USPS Change-of-Address website to MYMOVE.com, where you can verify your information.
      </p>
      <InputCheckbox
        v-if="!autofill"
        id="amp-offers-temp-checkbox"
        v-model="autofillSelected"
        name="autofill-offers-temp"
        class="c-input-checkbox--lg mt-6"
        @input="trackAutofill"
      >
        <p class="amp-offers__text-sm">
          By checking this box, you are voluntarily providing your consent to transfer a copy of your personal contact information to MYMOVE in order to autofill your MYMOVE registration.
        </p>
      </InputCheckbox>
      <button
        id="continue-offers-temp"
        :class="{ 'c-btn--disabled': loading }"
        :disabled="loading"
        type="button"
        class="c-btn mt-6"
        @click="next"
      >
        Continue
      </button>
      <div class="c-hairline mt-6" />
      <p class="amp-offers__text-sm mt-6">
        Once on MYMOVE.com, you will be subject to the MYMOVE Privacy Policy and Terms and Conditions.
      </p>
    </div>
  </section>
</template>

<script>
import { InputCheckbox } from '@mgo/ui';
import { track } from '../../analytics/events';
import { validateHandoffUrl } from '../../utils/commonUtil';

export default {
  name: 'OffersDesktop',
  components: {
    InputCheckbox,
  },
  props: {
    forwardType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      autofillSelected: false,
      loading: false,
    };
  },
  computed: {
    autofill: () => JSON.parse(sessionStorage.getItem('autofill')),
    doubleJeporady() {
      return [this.autofill, this.autofillSelected].includes(true);
    },
  },
  methods: {
    trackAutofill() {
      track('ElementClicked', {
        name: `autofill-toggled-${this.doubleJeporady ? 'on' : 'off'}`,
      });
    },
    async next(e) {
      this.loading = true;

      track('ElementClicked', { name: e.target.id });
      let dest = 'vr';
      if (this.forwardType === 'TEMPORARY') {
        dest = 'offers';
      }
      const { url } = await this.$coa.handoffGetURL(dest, this.doubleJeporady, this.$route.query);

      const validUrl = validateHandoffUrl(url);
      if (!validUrl) {
        this.loading = false;
        return;
      }
      window.location.href = validUrl;
    },
  },
};
</script>
